var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customize-exercise",style:({padding: _vm.padding})},[_c('h4',{staticClass:"customize-exercise__title",style:({margin: _vm.titleMargin})},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }